import { fetchRequest } from "@providers/conect";

const getAllEmpresasApi = async () => {
  try {
    const url = `empresas/all`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewEmpresasApi = async (data) => {
  try {
    const url = `empresas/view`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  getAllEmpresasApi,
  viewEmpresasApi
};

// Actualización de empresa por id
const updateEmpresaApi = async (id, data) => {
  try {
    const url = `empresas/update/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { updateEmpresaApi };